import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
};

export const clientSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    addData: (state) => {
      state.data = [
        {
          SNo: 1,
          userId: 'U0001',
          name: 'Sunil patel',
          email: 'sunil@growero.com',
          phone: '9393493323',
          Status: true,
        },
        {
          SNo: 2,
          userId: 'U0002',
          name: 'Vinit parmar',
          email: 'vinit@growero.com',
          phone: '9456134422',
          Status: false,
        },
        {
          SNo: 2,
          userId: 'U0002',
          name: 'Vinit parmar',
          email: 'vinit@growero.com',
          phone: '9456134422',
          Status: false,
        },
        {
          SNo: 2,
          userId: 'U0002',
          name: 'Vinit parmar',
          email: 'vinit@growero.com',
          phone: '9456134422',
          Status: false,
        },
      ];
    },
    // increment: (state) => {
    //   // Redux Toolkit allows us to write "mutating" logic in reducers. It
    //   // doesn't actually mutate the state because it uses the Immer library,
    //   // which detects changes to a "draft state" and produces a brand new
    //   // immutable state based off those changes
    //   state.value += 1
    // },
  },
});

// Action creators are generated for each case reducer function
export const { addData } = clientSlice.actions;

export default clientSlice.reducer;
